import React from 'react'
// general imports
import { IconPropsType } from '../types'

const AdminTransactionIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_15345_5986)'>
        <path
          d='M9.01 14H2V16H9.01V19L13 15L9.01 11V14ZM14.99 13V10H22V8H14.99V5L11 9L14.99 13Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_15345_5986'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AdminTransactionIcon
